import React from 'react';
import BookingFromToDatePicker, {CollapsibleMonthlyAutoRenewalAlert} from "../../BookingFromToDatePicker";
import BookingDetailsFieldToggle from "./BookingDetailsField/BookingDetailsFieldToggle";
import moment from "moment";
import {Grid} from "@mui/material";
import type {ReactNode} from "react";

const alertSx = {
  margin: '0em 0em 0.71em 0em',
} as const;


interface BookingDetailsDatePickerProps {
  editMode: boolean;
  onToggleEditMode: (value: boolean, event?: React.MouseEvent) => void;
  showEndDate: boolean;
  fromDate: string | moment.Moment;
  onFromDateChange: (date: string | moment.Moment) => void;
  toDate: string | moment.Moment;
  onToDateChange: (date: string | moment.Moment) => void;
  disablePast?: boolean;
  readOnly?: boolean;
  prePendedIcon?: ReactNode;
  postPendedIcon?: ReactNode;
}

const BookingDetailsDatePicker = (props: BookingDetailsDatePickerProps) => {
  const {
    editMode,
    onToggleEditMode,
    showEndDate,
    fromDate,
    onFromDateChange,
    toDate,
    onToDateChange,
    disablePast,
    readOnly,
    prePendedIcon,
    postPendedIcon,
  } = props;

  const handleToggleEdit = (value: boolean, event?: React.MouseEvent) => {
    if (!readOnly) {
      onToggleEditMode(value, event);
    }
  };

  const formatDatesText = (startDate: string | moment.Moment, endDate: string | moment.Moment): string => {
    const momentStartDate = moment(startDate);
    if (!showEndDate) {
      if (moment().isSame(momentStartDate, 'year')) {
        return momentStartDate.format("MMMM DD");
      }
      return momentStartDate.format("MMMM DD, YYYY");
    }
    const momentEndDate = moment(endDate);
    if (momentStartDate.isSame(momentEndDate, 'year')) {
      if (momentStartDate.isSame(momentEndDate, 'month')) {
        return `${momentStartDate.format("MMMM DD")} - ${momentEndDate.format("DD")}`
      }
      return `${momentStartDate.format("MMMM DD")} - ${momentEndDate.format("MMMM DD")}`;
    }
    return `${momentStartDate.format("MMMM DD, YYYY")} - ${momentEndDate.format("MMMM DD, YYYY")}`;
  };

  return (
    <>
      <BookingDetailsFieldToggle title={'Dates'} open={editMode && !readOnly} value={formatDatesText(fromDate, toDate)}
                                 onChange={handleToggleEdit} disableToggle={readOnly} toggleButtonClassName={editMode ? 'ss-margin-bottom-8' : ''}>
        <BookingFromToDatePicker
          showEndDate={showEndDate}
          fromDate={fromDate as unknown as object}
          onFromDateChange={onFromDateChange}
          toDate={toDate as unknown as object}
          onToDateChange={onToDateChange}
          disablePast={disablePast}
          disableBookingChanges={readOnly}
          prePendedIcon={prePendedIcon}
          postPendedIcon={postPendedIcon}
          hideAutoRenewalNotice
        />
      </BookingDetailsFieldToggle>
      <Grid item xs={12} sx={!showEndDate ? alertSx : undefined}>
        <CollapsibleMonthlyAutoRenewalAlert showEndDate={showEndDate} />
      </Grid>
    </>
  );
};

export default BookingDetailsDatePicker;
